import React from 'react';

const InputFile = ({ onUploadFile }) => {

	return (
		<div className='pa2 f3'>
			<input
				type='file'
				name='file-input'
				onChange={onUploadFile}
				accept='.xml'
				className='mv2 f5 w-100'
				/>
		</div>
		)
}

export default InputFile;